import React from "react";
import styled from "styled-components";

const DropDownContainer = styled.div`
  width: 70%;
  position: absolute;
  display: grid;
  gap: 5rem;
  z-index: 2;
  background: #fcfcfc;
  border: 1px solid var(--color-grey);
`;

const ClosingButton = styled.div`
  z-index: 1;
  background: transparent;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
`;

const ItemList = styled.div`
  padding: 0.5rem 0;
  display: grid;
  grid-auto-flow: row;
  gap: 0.1rem;
`;

const Item = styled.label`
  display: grid;
  align-items: center;
  grid-template-columns: 100%;
  padding: 0.5rem 2rem;
  cursor: pointer;
  color: var(--color-grey);

  &:hover {
    color: var(--filter-button-hovered-color);
    background: var(--group-hover-color);
  }

  & span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SingleSelectDropDown = ({
  items,
  selectedId,
  onSelect,
  onCloseDropdown
}) => {
  const handleClick = id => {
    if (onSelect) onSelect(id);
    if (onCloseDropdown) onCloseDropdown();
  };

  return (
    <div>
      <ClosingButton onClick={() => onCloseDropdown && onCloseDropdown()} />
      <DropDownContainer>
        <ItemList>
          {items.map(item => (
            <Item
              onClick={() => handleClick(item.id)}
              key={item.id || "__empty__"}
            >
              <span>{item.name}</span>
            </Item>
          ))}
        </ItemList>
      </DropDownContainer>
    </div>
  );
};

export default SingleSelectDropDown;
